import React, { useState } from "react";
import { Button, Flex, Text, Icon, Tooltip } from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  textPrimary,
  primaryAlt,
  white,
  newBorder,
} from "../../../../utils/colors";
import WarningModal from "../../../../components/buttons/partials/WarningModal";

const AddServiceButton = ({
  tpStatus,
  setAddServiceModalOpen,
  setStatus,
  resetServicesStatusToUncompleted,
}) => {
  const { t } = useTranslation();

  // STATE
  const [warningModal, setWarningModal] = useState(false);
  const [warningTitle, setWarningTitle] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const [warningButtons, setWarningButtons] = useState(false);
  const [pendingStatus, setPendingStatus] = useState("");

  // HANDLERS
  const handleAddService = () => {
    if (tpStatus === "approved") {
      setWarningTitle(t("warnings.cancelledAddServiceStatusWarningTitle"));
      setWarningMessage(t("warnings.cancelledAddServiceStatusWarningMessage"));
      setWarningButtons(true);
      setPendingStatus("planning");
      setWarningModal(true);
    } else if (tpStatus === "ongoing") {
      setWarningTitle(t("warnings.cancelledAddServiceStatusWarningTitle"));
      setWarningMessage(
        t("warnings.cancelledOngoingAddServiceStatusWarningMessage")
      );
      setWarningButtons(true);
      setPendingStatus("planning");
      setWarningModal(true);
    } else {
      setAddServiceModalOpen(true);
    }
  };

  const confirmModalHandler = () => {
    setWarningModal(false);

    setStatus(pendingStatus);

    if (pendingStatus === "planning") {
      resetServicesStatusToUncompleted(); // Call the function from the parent
    }

    setAddServiceModalOpen(true);
  };

  const cancelModal = () => {
    setWarningModal(false);
  };

  // LOGS
  // console.log("tpStatus in AddServiceButton:", tpStatus);
  // console.log("pendingStatus in AddServiceButton:", pendingStatus);

  return (
    <>
      {warningModal && (
        <WarningModal
          open={warningModal}
          setOpen={setWarningModal}
          warningTitle={warningTitle}
          warningMessage={warningMessage}
          warningButtons={warningButtons}
          statusBefore={tpStatus}
          statusAfter={pendingStatus}
          confirmHandler={confirmModalHandler}
          cancelHandler={cancelModal}
          pendingStatus={pendingStatus}
        />
      )}

      <Tooltip
        p="0.5rem 0.5rem"
        borderRadius="1rem"
        placement="top"
        label={
          <Flex direction="column" align="center" justify="center">
            {tpStatus === "cancelled" ? (
              <Text fontSize="xs" fontWeight="500" textAlign="center">
                {t("warnings.tooltipCancelledChangePriceQuantityText")}
              </Text>
            ) : tpStatus === "approved" ? (
              <Text fontSize="xs" fontWeight="500" textAlign="center">
                {t("warnings.tooltipOnlyPlanningChangePriceQuantityText")}
              </Text>
            ) : tpStatus === "ongoing" ? (
              <Text fontSize="xs" fontWeight="500" textAlign="center">
                {t(
                  "warnings.tooltipOngoingOnlyPlanningChangePriceQuantityText"
                )}
              </Text>
            ) : (
              tpStatus === "completed" && (
                <Text fontSize="xs" fontWeight="500" textAlign="center">
                  {t("warnings.tooltipCompletedChangePriceQuantityText")}
                </Text>
              )
            )}
          </Flex>
        }
        isDisabled={tpStatus === "planning" || tpStatus === "draft"}
      >
        <Button
          size="sm"
          // borderRadius="1rem"
          bg={textPrimary}
          border={`0px solid ${newBorder}`}
          color={white}
          borderRadius="10rem"
          onClick={handleAddService}
          _hover={{ bg: primaryAlt, color: white }}
          isDisabled={
            tpStatus === "cancelled" ||
            tpStatus === "completed" ||
            tpStatus === "approved" ||
            tpStatus === "ongoing"
          }
        >
          <Icon as={FaPlus} fontSize="0.75rem" fontWeight="400" mr="0.25rem" />
          <Text fontSize="0.875rem" fontWeight="500">
            {t("service.addServiceButtonLabel")}
          </Text>
        </Button>
      </Tooltip>
    </>
  );
};

export default AddServiceButton;
